import { Box, Button } from '@mui/material'
import { FormFileInput } from '../form/FormFileInput'

import { useTranslator } from '../../hooks/useTranslator'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Company, getCompanySchema, useCompanyImportMutation } from '@/@data'
import { useNotification } from '@/hooks'
import { useQuery } from '@tanstack/react-query'
import { InvalidEmployerImportDialog } from '../user/modal/InvalidEmployerImportDialog'

export const EmployerImportFileForm = ({ onClose, refetch }: { onClose: () => void; refetch: () => void }) => {
  const { __ } = useTranslator()
  const { mutate: importCompany } = useCompanyImportMutation()
  const [open, setOpen] = useState<boolean>(false)
  const [err, setErr] = useState<any>()

  const { data: importData } = useQuery({
    ...Company.getImportTemplate()
  })

  const n = useNotification()

  const methods = useForm<any>({
    defaultValues: {
      file: null
    },
    mode: 'onChange',
    resolver: yupResolver(getCompanySchema(__))
  })

  const {
    formState: { isValid, isDirty }
  } = methods

  const onSubmit = (data: any) => {
    const formData = new FormData()

    formData.append('file', data.file[0])

    importCompany(
      { data: formData },
      {
        onSuccess: ({ data }: { data: any }) => {
          if (data?.errorCount > 0 && data?.errors) {
            setErr(data)
            setOpen(true)
          } else {
            n.success(data.message)
            onClose()
          }

          refetch()
        },
        onError: error => {
          n.error(error.message)
        }
      }
    )
  }

  const handleDownload = () => {
    if (!importData) {
      n.error(__('No template available'))

      return
    }

    const url = window.URL.createObjectURL(importData)
    const link = document.createElement('a')

    link.href = url
    link.setAttribute('download', 'company_template.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }

  const handleClose = () => {
    setOpen(false)
    methods.setValue('file', null)
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Box className='flex flex-col gap-6'>
            <FormFileInput
              name='file'
              label={__('File')}
              placeholder={__('Import File')}
              required
              accept='.xlsx, .xls, .csv'
              fullWidth
              control={methods.control}
              onClear={() => methods.setValue('file', null)}
            />
            <div className='flex justify-between gap-4'>
              <Button
                variant='contained'
                className='text-white text-[15px] font-medium leading-[22px] bg-[#3551F2] shadow-none rounded-full w-full'
                type='submit'
                disabled={!isValid || !isDirty}
              >
                {__('Submit')}
              </Button>
              <Button
                variant='contained'
                className='text-[#FF4C51] text-[15px] font-medium leading-[22px] bg-[#FCE2E3] shadow-none rounded-full w-full'
                onClick={onClose}
              >
                {__('Cancel')}
              </Button>
            </div>
            <Button
              variant='contained'
              className='text-[#ffffff  ] text-[15px] font-medium leading-[22px] bg-[#00BAD1] shadow-none rounded-full w-full'
              startIcon={<i className='tabler-download fa-download'></i>}
              onClick={handleDownload}
            >
              {__('Download Template')}
            </Button>
          </Box>
        </form>
      </FormProvider>
      <InvalidEmployerImportDialog open={open} data={err || []} onClose={handleClose} />
    </>
  )
}
